import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import * as usaLow from '@amcharts/amcharts4-geodata/usaLow'
import geojson from './cb_2018_us_region_20m'

export function createPolygonSeries (mapType, map, data) {
  if (mapType === 'region' && data) {
    data.forEach(datum => {
      switch (datum.id) {
        case 'MW':
          datum.id = 'Midwest'
          break
        case 'S':
          datum.id = 'South'
          break
        case 'NE':
          datum.id = 'Northeast'
          break
        case 'W':
          datum.id = 'West'
          break
      }
    })
  }

  // Create map polygon series
  let polygonSeries = new am4maps.MapPolygonSeries()
  // Set min/max fill color for each area
  polygonSeries.heatRules.push({
    property: 'fill',
    target: polygonSeries.mapPolygons.template,
    min: am4core.color('#f6eff7'),
    max: am4core.color('#016c59')

  })

  // Make map load polygon data (state shapes and names) from GeoJSON
  polygonSeries.useGeodata = true
  // Set heatmap values for each state
  polygonSeries.data = data

  // Configure series tooltip
  let polygonTemplate = polygonSeries.mapPolygons.template
  polygonTemplate.adapter.add('tooltipText', function (value, target) {
    if (target.dataItem.dataContext.valueSuppressed) {
      return (value += ' Suppressed')
    } else if (!target.dataItem.dataContext.value) {
      return (value += ' N/A')
    }
    return value
  })
  polygonTemplate.tooltipText = '{id}: [bold]{value}'
  polygonTemplate.nonScalingStroke = true
  polygonTemplate.strokeWidth = 0.5

  let hs = polygonTemplate.states.create('hover')
  hs.properties.stroke = am4core.color('#006837')
  hs.properties.strokeWidth = 3
  return polygonSeries
}

export function createMap (mapType, data, element, titleString) {
  // Create map instance
  let map = am4core.create(element, am4maps.MapChart)
  if (mapType === 'region') {
    map.geodata = geojson
  } else if (mapType === 'state') {
    map.geodata = usaLow.default
  } else {
    throw String('Chloropleth Heatmap requires mapType to be state or region')
  }

  // Disable zoom in/out
  map.maxZoomLevel = 1

  // Disable panning
  map.seriesContainer.draggable = false
  map.seriesContainer.resizable = false
  map.chartContainer.wheelable = false

  map.seriesContainer.paddingTop = am4core.percent(3)

  // Set projection
  map.projection = new am4maps.projections.AlbersUsa()
  let polygonSeries = createPolygonSeries(mapType, map, data)

  map.series.push(polygonSeries)

  var topContainer = map.chartContainer.createChild(am4core.Container)
  topContainer.layout = 'absolute'
  topContainer.toBack()
  topContainer.paddingBottom = am4core.percent(30)
  topContainer.marginBottom = am4core.percent(10)
  topContainer.width = am4core.percent(100)

  var title = topContainer.createChild(am4core.Label)
  title.text =
    '[font-size: 1.75rem font-weight: 500 line-height:1.2]' +
    titleString +
    '[/]'
  // if (Object.keys(this.filters).includes('question')) {
  //   title.text += ' (' + this.getLabelForSelectedOption('question') + ')'
  // }
  title.align = 'left'
  title.width = am4core.percent(100)
  title.paddingBottom = am4core.percent(10)
  title.wrap = true
  return [map, title]
}
